import { useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { FirebaseContext } from '@/session/FirebaseContext';
import { ACTIVE_TOURNAMENT } from '@/constants';
import type { LiveMatch } from '@/models/liveMatch';

/** Live WC-26 matches from Firestore (public read). */
export function useLiveMatches(): LiveMatch[] {
  const ctx = useContext(FirebaseContext);
  const [liveMatches, setLiveMatches] = useState<LiveMatch[]>([]);

  useEffect(() => {
    return onSnapshot(
      query(
        collection(ctx.db, 'competitions', ACTIVE_TOURNAMENT, 'liveMatches'),
        orderBy('lastUpdated', 'desc'),
      ),
      (snapshot) => {
        setLiveMatches(
          snapshot.docs
            .map((doc) => doc.data() as LiveMatch)
            .filter((match) => match.status !== 'ft'),
        );
      },
      (error) => {
        console.error(error);
      },
    );
  }, [ctx.db]);

  return liveMatches;
}
